import type {Dispatch} from "redux";

import {IFetchContext} from "@pg-mono/data-fetcher";
import {appendQueryString, catch400, getRequest, type IQueryValue} from "@pg-mono/request";
import {createRequestActionTypes} from "@pg-mono/request-state";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes/";

import {IRPStore} from "../../../app/rp_reducer";
import {IRPRequestMeta} from "../../../app/rp_request_meta";
import type {IPropertyListProperty} from "../../../property/types/PropertyListProperty";
import type {IPaginatedResponse} from "../../../request/IResponse";
import {offerDetailPropertiesListConstraints} from "../../constants/offer_detail_properties_list_constraints";
import {OfferType} from "../../types/OfferType";

const FETCH_OFFER_DETAIL_LOWEST_PRICE_PROPERTY = "offer_detail/FETCH_OFFER_DETAIL_LOWEST_PRICE_PROPERTY";

interface IOfferDetailLowestPricePropertyResponse extends IPaginatedResponse {
    results: IPropertyListProperty[];
}

export const fetchOfferDetailLowestPricePropertyTypes = createRequestActionTypes(FETCH_OFFER_DETAIL_LOWEST_PRICE_PROPERTY);

export const fetchOfferDetailLowestPricePropertyAtRoute = (ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: Dispatch, getState: () => IRPStore) => {
    dispatch({type: fetchOfferDetailLowestPricePropertyTypes.start});

    const {offer} = getState().offerDetail;
    const preferences = getState().user.preferences?.data?.filters;
    const offerType = getState().offerDetail.offer?.type;

    const url = appendQueryString(apiV2ListLink.property.list(Scenario.PROPERTY_LIST), {
        ...offerDetailPropertiesListConstraints,
        offer: offer?.id,
        page_size: 1,
        page: 1,
        sort: "price",
        rooms_0: preferences?.rooms_0,
        rooms_1: preferences?.rooms_1,
        area_0: preferences?.area_0,
        area_1: preferences?.area_1,
        ...(offerType === OfferType.FLAT ? {floor_choices: preferences?.floor_choices} : {})
    });

    return getRequest(ctx.meta, url).then((response: IOfferDetailLowestPricePropertyResponse) => {
        dispatch({type: fetchOfferDetailLowestPricePropertyTypes.success, result: response.results[0] ?? null});
    });
};

export const fetchOfferDetailLowestPriceProperty =
    (offer: number, filters: Record<string, IQueryValue> = {}) =>
    async (dispatch: Dispatch): Promise<IPropertyListProperty[] | void> => {
        dispatch({type: fetchOfferDetailLowestPricePropertyTypes.start, offer});

        const query = {offer, ...filters, page_size: 1, page: 1, sort: "price", ...offerDetailPropertiesListConstraints};

        const url = appendQueryString(apiV2ListLink.property.list(Scenario.PROPERTY_LIST), query);

        return getRequest({}, url)
            .then((response: IOfferDetailLowestPricePropertyResponse) => {
                dispatch({type: fetchOfferDetailLowestPricePropertyTypes.success, result: response.results[0] ?? null, offer});
            })
            .catch(
                catch400((error) => {
                    dispatch({type: fetchOfferDetailLowestPricePropertyTypes.error, error, offer});
                })
            );
    };
